import React from "react";
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBRow,
  MDBCol,
  MDBCardImage,
} from "mdb-react-ui-kit";

function TitleWithImageCard({ title, img }) {
  return (
    <MDBCard alignment="left" className="p-4 w-100">
      <MDBRow className="my-3 d-flex">
        <MDBCol size="3">
          <MDBCardTitle></MDBCardTitle>
          <MDBCardImage className="img-fluid rounded" src={img} alt="..." />
        </MDBCol>
        <MDBCol size="7">
          <MDBCardBody className="p-3 my-4">
            <h2>{title}</h2>
          </MDBCardBody>
        </MDBCol>
        <MDBCol size="2"></MDBCol>
      </MDBRow>
    </MDBCard>
  );
}

export default TitleWithImageCard;
